import { getCoreDataSecurityMonitorsByApplicationSlice } from './get';

export const { requestGetCoreDataSecurityMonitorsByApplication, resetGetCoreDataSecurityMonitorsByApplication } =
    getCoreDataSecurityMonitorsByApplicationSlice.asyncActionCreators;
